import { Case } from "@types-runway/case";
import { PaymentOption, PaymentOptionKind } from "@types-runway/paymentRetry";
import { PAYMENT_PROVIDER_STRIPE, PAYMENT_PROVIDER_WITHFLEX } from "@utils/constantsEnv";

const payByCard = (case_: Case): PaymentOption =>
  case_.paymentProvider === PAYMENT_PROVIDER_WITHFLEX
    ? { kind: PaymentOptionKind.PAY_BY_CARD, invoiceProvider: PAYMENT_PROVIDER_STRIPE }
    : { kind: PaymentOptionKind.PAY_BY_CARD };

const retryHsaFsa: PaymentOption = {
  kind: PaymentOptionKind.RETRY_HSA_FSA,
  invoiceProvider: PAYMENT_PROVIDER_WITHFLEX,
};

export const derivePaymentOptions = (case_: Case): PaymentOption[] =>
  case_.paymentProvider === PAYMENT_PROVIDER_WITHFLEX
    ? [payByCard(case_), retryHsaFsa]
    : [payByCard(case_)];
